import { useListQuery as useEventsQuery } from 'store/api/event';
import { useListQuery as useStoragesQuery } from 'store/api/storage';

import { transferDefaultEventId } from './config';

/**
 * Owner 2026-10-16: the event a record's LTL freight goes to when it has no
 * split, from its storages: an event's storage belongs to that event; a
 * general storage (e.g. "Orlando") to none. The same lists the transfer and
 * stock order forms already read (cached).
 */
export const useStorageEventLookup = () => {
  const { data: events } = useEventsQuery({ limit: 10000, status: 'accepted' });
  const { data: storages } = useStoragesQuery();
  return (storageId?: number | null): number | null => {
    if (!storageId) {
      return null;
    }
    const byEvent = events?.rows?.find(
      (event) => Number(event.storage?.id) === Number(storageId)
    );
    if (byEvent) {
      return Number(byEvent.id);
    }
    const storage = storages?.find(
      (row) => Number(row.id) === Number(storageId)
    );
    return storage?.eventId ? Number(storage.eventId) : null;
  };
};

/** A transfer form's default event (receiving event / L13 source event). */
export const useTransferDefaultEventId = () => {
  const eventOf = useStorageEventLookup();
  return (values: {
    type?: string | null;
    sourceStorageId?: number | null;
    destinationStorageId?: number | null;
  }) =>
    transferDefaultEventId({
      type: values.type,
      sourceEventId: eventOf(values.sourceStorageId),
      destinationEventId: eventOf(values.destinationStorageId),
    });
};
